// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nackle-menu .nkl-menu {
  padding-bottom: 48px;
}
.nackle-menu .nkl-layout-sider .menu-category {
  display: flex;
  align-items: center;
  padding-left: 0.2rem;
}
.nackle-menu .nkl-layout-sider .text {
  opacity: 1 !important;
  transition: all 200ms linear;
}
.nackle-menu .nkl-layout-sider-collapsed .text {
  opacity: 0 !important;
}
.nackle-menu .nkl-menu-submenu-title {
  display: flex;
  align-items: center;
}
.nackle-menu .nkl-menu-submenu-title .anticon {
  margin-right: 0.75rem;
}
.nackle-menu .nkl-menu-submenu-title .anticon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.nackle-menu .nkl-menu-submenu-title svg + span {
  margin-left: 1rem;
}
.nackle-menu .nackle-menu-activity-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.nackle-menu .anticon.menu-icon {
  line-height: 1 !important;
}
.nackle-menu .nackle-menu-collapsed-header {
  display: none;
}
.nackle-menu-collapsed-header .nkl-menu-item-group-title {
  font-weight: bold;
  border-bottom: 1px solid rgba(0, 0, 0, 0.45);
}
.nackle-menu-collapsed-header.dark .nkl-menu-item-group-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.65);
}
.nackle-menu .nkl-menu-item-group-title:empty {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nackle/menu/dist/nackle-menu.less"],"names":[],"mappings":"AAAA;EAEQ,oBAAA;AAAR;AAFA;EAMY,aAAA;EACA,mBAAA;EACA,oBAAA;AADZ;AAPA;EAYY,qBAAA;EACA,4BAAA;AAFZ;AAXA;EAmBY,qBAAA;AALZ;AAdA;EAgCQ,aAAA;EACA,mBAAA;AAfR;AAlBA;EAoCY,qBAAA;AAfZ;AArBA;EAwCY,aAAA;EACA,cAAA;AAhBZ;AAzBA;EA6CY,iBAAA;AAjBZ;AA5BA;EAkDQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAnBR;AAnCA;EA0DQ,yBAAA;AApBR;AAtCA;EA8DQ,aAAA;AArBR;AAyBA;EAEQ,iBAAA;EACA,4CAAA;AAxBR;AA4BA;EAEQ,kDAAA;AA3BR;AA+BA;EACI,UAAA;AA7BJ","sourcesContent":[".nackle-menu {\n    .nkl-menu {\n        padding-bottom: 48px;\n    }\n    .nkl-layout-sider {\n        .menu-category {\n            display: flex;\n            align-items: center;\n            padding-left: .2rem;\n        }\n\n        .text {\n            opacity: 1 !important;\n            transition: all 200ms linear;\n        }\n    }\n\n    .nkl-layout-sider-collapsed {\n        .text {\n            opacity: 0 !important;\n        }\n    }\n\n    .nkl-layout-content.page-content {\n        //flex-shrink: 0;\n\n        .nkl-table-wrapper {\n            //margin: 0 1.5rem 1.5rem 1.5rem;\n        }\n    }\n\n    .nkl-menu-submenu-title {\n        display: flex;\n        align-items: center;\n\n        .anticon {\n            margin-right: .75rem;\n        }\n\n        .anticon svg {\n            width: 1.5rem;\n            height: 1.5rem;\n        }\n\n        svg + span {\n            margin-left: 1rem;\n        }\n    }\n\n    .nackle-menu-activity-indicator {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n    }\n\n    .anticon.menu-icon {\n        line-height: 1 !important;\n    }\n\n    .nackle-menu-collapsed-header {\n        display: none;\n    }\n}\n\n.nackle-menu-collapsed-header {\n    .nkl-menu-item-group-title {\n        font-weight: bold;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.45)\n    }\n}\n\n.nackle-menu-collapsed-header.dark {\n    .nkl-menu-item-group-title {\n        border-bottom: 1px solid rgba(255, 255, 255, 0.65);\n    }\n}\n\n.nackle-menu .nkl-menu-item-group-title:empty {\n    padding: 0;\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
